class RingCustomizer extends CustomizerBase {
  constructor() {
    super();
    this.textInput = this.querySelector('.js-text-input');
    this.enamelSwatch = this.querySelectorAll('.js-enamel-swatch');
    this.symbolTypeSwatch = this.querySelectorAll('.js-symbol-type-swatch');
    this.config = window.customizer.ring.config;
    this.symbolGradients = window.customizer.ring.symbolGradients;
    this.enamelGradients = window.customizer.ring.enamelGradients;
  }
  dataLoad() {
    return (
      this.localStore.find((record) => record.handle === this.handle) || {
        id: this.handle,
        handle: this.handle,
        type: this.type,
        variantColor: this.variantColor,
        text: this.text,
        enamelColor: this.enamelColor,
        fontFamily: this.fontFamily,
        symbolType: this.symbolType,
      }
    );
  }
  get text() {
    return this.data?.text || 'R';
  }
  set text(txt) {
    this.data.text = txt;
    this.dataSave();
  }
  get fontFamily() {
    return this.data?.fontFamily || 'Lily Script One';
  }
  set fontFamily(font) {
    this.data.fontFamily = font;
    this.dataSave();
  }
  get enamelColor() {
    return this.data?.enamelColor || 'black';
  }
  set enamelColor(color) {
    this.data.enamelColor = color;
    this.dataSave();
  }
  get symbolType() {
    return this.data?.symbolType || this.dataset.symbolType;
  }
  set symbolType(type) {
    this.data.symbolType = type;
    this.dataSave();
  }
  get symbol() {
    return this.data?.symbol || this.querySelector('.js-symbol-swatch:checked').dataset.valueHandle;
  }
  set symbol(src) {
    this.data.symbol = src;
    this.dataSave();
  }
  get textStyle() {
    return new this.pixi.TextStyle({
      fontFamily: this.fontFamily,
      fontSize: this.config.text.fontSize,
      fontStyle: this.config.text.fontStyle,
      padding: this.config.text.padding,
      fill: '#ffffff',
      align: 'center',
    });
  }

  get symbolGradientFilter() {
    const stops = this.symbolGradients.find((g) => g.color === this.variantColor).stops;
    return new this.pixi.filters.ColorGradientFilter({
      type: 0,
      stops,
      angle: this.config.symbol.gradientAngle,
      alpha: 1,
    });
  }
  get enamelGradientFilter() {
    const stops = this.enamelGradients.find((g) => g.color === this.enamelColor).stops;
    return new this.pixi.filters.ColorGradientFilter({
      type: 0,
      stops,
      angle: this.config.enamel.gradientAngle,
      alpha: 1,
    });
  }

  addEvents() {
    super.addEvents();

    this.textInput?.addEventListener('input', (e) => {
      const value = e.target.value.toUpperCase();
      e.target.value = value;
      this.text = value;
      this.render();
    });

    this.textInput?.addEventListener('keypress', function (e) {
      const char = String.fromCharCode(e.which);
      if (!/^[a-zA-Z]$/.test(char)) {
        e.preventDefault(); // block the key press
      }
    });

    this.enamelSwatch.forEach((enamelSwatch) => {
      enamelSwatch.addEventListener('change', this.handleEnamelSelect.bind(this));
    });
    this.symbolTypeSwatch.forEach((symbolType) => {
      symbolType.addEventListener('change', this.handleSymbolTypeSwatch.bind(this));
    });

    this.querySelectorAll('.js-symbol-swatch').forEach((symbolSwatch) => {
      symbolSwatch.addEventListener('change', this.handleSymbolSwatch.bind(this));
    });
    this.querySelectorAll('.js-customizer-font').forEach((fontSwatch) => {
      fontSwatch.addEventListener('change', this.handleFontSwatchSelect.bind(this));
    });
  }

  init() {
    WebFont.load({
      google: {
        families: ['Lily Script One'],
      },
      active: async () => {
        await super.init();
        this.initControls();
        this.render();
      },
    });
  }
  initControls() {
    super.initControls();
    this.textInput.value = this.text;
    this.querySelectorAll('.js-symbol-swatch').forEach((symbolSwatch) => {
      if (symbolSwatch.dataset.valueHandle == this.symbol) symbolSwatch.click();
    });
    this.symbolTypeSwatch.forEach((symbolTypeSwatch) => {
      if (symbolTypeSwatch.dataset.valueHandle == this.symbolType) symbolTypeSwatch.click();
    });
    this.enamelSwatch.forEach((enamelSwatch) => {
      if (enamelSwatch.dataset.valueHandle == this.enamelColor) enamelSwatch.click();
    });
    this.querySelectorAll('.js-customizer-font').forEach((fontSwatch) => {
      if (fontSwatch.dataset.valueHandle == this.fontFamily) fontSwatch.click();
    });
  }
  render() {

    this.refreshCanvas();

    // enamel
    const enamel = new this.pixi.Graphics()
      .ellipse(0, 0, this.config.enamel.width, this.config.enamel.height)
      .fill('black');
    enamel.position.set(this.config.enamel.x, this.config.enamel.y);
    enamel.angle = this.config.enamel.angle;
    enamel.zIndex = 4;
    enamel.filters = [this.enamelGradientFilter];

    // symbol
    if (this.symbolType == 'text') {
      const text = new this.pixi.Text(this.text, this.textStyle);
      text.anchor.set(0.5);
      text.x = this.config.text.x;
      text.y = this.config.text.y;
      text.angle = this.config.text.angle;
      text.skew.y = -0.2;
      text.zIndex = 5;
      text.filters = [this.symbolGradientFilter];
      this.app.stage.addChild(text);
    }
    if (this.symbolType == 'symbol') {
      const texturePromise = this.pixi.Assets.load(this.symbol);
      texturePromise.then((texture) => {
        const image = this.pixi.Sprite.from(this.symbol);
        const ratio = texture.orig.height / texture.orig.width;
        image.anchor.set(0.5);
        image.angle = this.config.symbol.angle;
        image.height = this.config.symbol.height;
        image.width = image.height / ratio;
        image.x = this.config.symbol.x;
        image.y = this.config.symbol.y;
        image.skew.y = -0.2;
        image.zIndex = 5;
        image.filters = [this.symbolGradientFilter];
        this.app.stage.addChild(image);
      });
    }

    this.app.stage.addChild(enamel);
    // debug center
    // const dot = new this.pixi.Graphics().circle(0, 0, 5).fill('red');
    // dot.position.set(text.x, text.y);
    // dot.zIndex = 5;
    // this.app.stage.addChild(dot);
    // console.log('w', text.width, 'h', text.height);
    // console.log('x', dot.x, 'y', dot.y);
  }

  handleEnamelSelect(e) {
    this.enamelColor = e.target.dataset.valueHandle;
    this.render();
  }
  handleSymbolTypeSwatch(e) {
    const type = e.target.dataset.valueHandle;
    this.dataset.symbolType = type;
    this.symbolType = type;
    this.render();
  }
  handleSymbolSwatch(e) {
    this.symbol = e.target.dataset.valueHandle;
    this.render();
  }
  handleFontSwatchSelect(e) {
    this.dataset.font = e.target.dataset.valueHandle;
  }
  variantChangeCallBack() {
    super.variantChangeCallBack();
    this.render();
  }
  async cartPrepare() {
    await super.cartPrepare();
    this.cartAppend(`properties[Enamel Color]`, this.enamelColor);
    if (this.symbolType == 'text') {
      this.cartAppend(`properties[Engraving Text]`, this.text);
    }
    if (this.symbolType == 'symbol') {
      const symbolName = this.querySelector('.js-symbol-swatch:checked').value;
      this.cartAppend(`properties[Engraving Symbol]`, symbolName);
      this.cartAppend(`properties[_symbol_image]`, this.symbol);
    }
  }
}
customElements.define('ring-customizer', RingCustomizer);
